import { DesktopClientPlatform } from 'interfaces/desktop-app/platform';

export function getDesktopPlatform(): DesktopClientPlatform {
  if (navigator.userAgent.indexOf('Mac') !== -1) {
    return DesktopClientPlatform.MacOS;
  } else {
    return DesktopClientPlatform.Windows;
  }
}
